<template>
    <b-card no-body>
        
        <b-modal id="create-or-update" :title="editing ? 'Bölüm Güncelle' : 'Bölüm Oluştur'" no-close-on-esc no-close-on-backdrop>
            <employee-department-create-or-update v-model="department"></employee-department-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <b-modal id="create-or-update-title" :title="editing ? 'Unvan Güncelle' : 'Unvan Oluştur'" no-close-on-esc no-close-on-backdrop>
            <employee-department-title-create-or-update v-model="title"></employee-department-title-create-or-update>
            <template #modal-footer><v-executer  :loading="loading" :editing="editing" :action="createOrUpdateTitle"></v-executer></template>
        </b-modal>

        <b-modal id="personal" :title="[title.Name,'Personel'].join(' - ')" body-class="p-75" scrollable hide-footer no-close-on-esc no-close-on-backdrop>
            <employee-title-personal v-model="title"></employee-title-personal>
        </b-modal>
        
        <b-overlay :show="getting" opacity="0.2" rounded="sm" :class="!departments.length ? 'p-3' : 'p-1'">
            <div class="text-right" v-if="departments.length">
                <button v-on:click="collapseAll" class="btn btn-sm mb-1 btn-light">
                    <feather-icon icon="MinusSquareIcon" class="mr-50"></feather-icon>
                    Hepsini Kapat
                </button>
            </div>
            <div v-for="(item,index) in departments" :key="index" :class="index != 0 ? 'mt-1' : null">
                <div class="alert alert-dark mb-0">
                    <div class="alert-body px-50 py-25">
                        <div class="row align-items-center p-25">
                            <div class="col">
                                {{item.BranchName}}
                            </div>
                            <div class="col-auto">
                                <button v-b-tooltip.noninteractive.hover.bottom title="Bölüm Ekle" v-on:click="createNew(item)" class="btn btn-sm rounded-circle btn-icon btn-primary mr-25">
                                    <feather-icon icon="PlusIcon"></feather-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <v-tree-view ref="treeViews" v-model="item.EmployeeDepartmentsTreeForms" >
                    <template #below-data="{data}">
                        <table v-if="data.EmployeeDepartmentTitles.length" class="table table-sm table-bordered mt-50 mb-25">
                            <thead>
                                <tr>
                                    <th>İşlemler</th>
                                    <th>Sıra</th>
                                    <th class="w-50">Unvan</th>
                                    <th class="w-25 text-nowrap">Organizasyonel Konum</th>
                                    <th class="w-25 text-nowrap">Yönetsel Düzey</th>
                                    <th class="text-nowrap">Mevcut Personel</th>
                                    <th class="text-nowrap">Norm Kadro Sayısı</th>
                                    <th>Sürücü</th>
                                    <th>İK</th>
                                    <th class="text-nowrap">Bakım Onarım</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(title,index) in data.EmployeeDepartmentTitles" :key="index">
                                    <td>
                                        <div class="d-flex">
                                            <button v-on:click="editTitle(title)" class="btn btn-icon btn-sm btn-flat-secondary mr-25">
                                                <feather-icon icon="Edit2Icon"></feather-icon>
                                            </button>
                                            <button v-on:click="delTitle(title)" class="btn btn-icon btn-sm btn-flat-danger ml-25">
                                                <feather-icon icon="TrashIcon"></feather-icon>
                                            </button>
                                        </div>
                                    </td>
                                    <td class="text-center">{{title.Order}}</td>
                                    <td>{{title.Name}}</td>
                                    <td>{{$safe(title.CollarStatus,'Name') || '-'}}</td>
                                    <td class="text-nowrap">
                                        {{ AdministrativeLevelId ? [$safe(title,'AdministrativeLevelGroupName'),$safe(title,'AdministrativeLevelName')].join(' - ') : '-' }}
                                    </td>
                                    <td>
                                        <div class="d-flex justify-content-between align-items-center">
                                            {{$safe(title,'CurrentTitleEmployees.Count') || '-'}}
                                            <template v-if="$safe(title,'CurrentTitleEmployees.Count') > 0">
                                                <button v-b-tooltip.noninteractive.hover.bottom title="Personal" v-on:click="showPersonal(data,title)" class="btn btn-sm btn-icon btn-outline-secondary">
                                                    <feather-icon icon="UsersIcon"></feather-icon>
                                                </button>
                                            </template>
                                        </div>
                                    </td>
                                    <td>{{title.MaxEmployeeCount}}</td>
                                    <td class="text-center align-middle">
                                        <span v-if="title.DriverDepartment == true" class="material-icons-outlined text-success d-block">check_circle</span>
                                        <span v-else class="material-icons-outlined text-danger d-block">cancel</span>
                                    </td>
                                    <td class="text-center align-middle">
                                        <span v-if="title.HRDepartment == true" class="material-icons-outlined text-success d-block">check_circle</span>
                                        <span v-else class="material-icons-outlined text-danger d-block">cancel</span>
                                    </td>
                                    <td class="text-center align-middle">
                                        <span v-if="title.MRODepartment == true" class="material-icons-outlined text-success d-block">check_circle</span>
                                        <span v-else class="material-icons-outlined text-danger d-block">cancel</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <template #data="{data}">
                        <div class="row align-items-center">
                            <div class="col">
                                <b>{{data.Name}}</b>
                            </div>
                            <div class="mr-50">
                                <b-badge variant="light-dark">Sıra: {{data.Order}}</b-badge>
                            </div>
                            <div class="col-auto text-right">
                                <button v-b-tooltip.noninteractive.hover.bottom title="Unvan Ekle" v-on:click="createNewTitle(data)" class="btn btn-sm rounded-circle btn-icon btn-success mr-25">
                                    <feather-icon icon="HexagonIcon"></feather-icon>
                                </button>
                                <button v-b-tooltip.noninteractive.hover.bottom title="Alt Bölüm Ekle" v-on:click="createNew(data)" class="btn btn-sm rounded-circle btn-icon btn-primary ml-25 mr-25">
                                    <feather-icon icon="PlusIcon"></feather-icon>
                                </button>
                                <button v-b-tooltip.noninteractive.hover.bottom title="Düzenle" v-on:click="edit(data)" class="btn btn-sm btn-icon btn-flat-secondary ml-25 mr-25">
                                    <feather-icon icon="Edit2Icon"></feather-icon>
                                </button>
                                <button v-b-tooltip.noninteractive.hover.bottom title="Sil" v-on:click="del(data)" class="btn btn-sm btn-icon btn-flat-danger ml-25">
                                    <feather-icon icon="TrashIcon"></feather-icon>
                                </button>
                            </div>
                        </div>
                    </template>
                </v-tree-view>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import { BCard,BOverlay,BBadge,VBTooltip,BFormCheckbox } from 'bootstrap-vue'
import VTreeView from '@/components/v-tree-view/VTreeView'
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
import EmployeeDepartmentCreateOrUpdate from './components/EmployeeDepartmentCreateOrUpdate'
import EmployeeDepartmentTitleCreateOrUpdate from './components/EmployeeDepartmentTitleCreateOrUpdate'
import EmployeeTitlePersonal from './components/EmployeeTitlePersonal.vue';

export default {
    components:{
        BCard,
        BFormCheckbox,
        BOverlay,
        VTreeView,
        EmployeeDepartmentCreateOrUpdate,
        EmployeeDepartmentTitleCreateOrUpdate,
        EmployeeTitlePersonal,
        BBadge,
    },
    directives:{
        "b-tooltip":VBTooltip
    },
    data(){
        return{
            departments:[],
            editing:false,
            loading:false,
            getting:false,
            department:{
                Id:null,
                Name:null,
                ParentEmployeeDepartmentId:null,
                BranchId:null,
                Order:null,
            },
            title:{
                Id:null,
                Name:null,
                BranchId:null,
                MaxEmployeeCount:null,
                EmployeeDepartmentId:null,
                Order:null,
                DriverDepartment:null,
                HRDepartment:null,
                CollarStatusId:null,
                Personal:[],
                AdministrativeLevelId:null,
                AdministrativeLevelGroupId:null
            },
        }
    },
    mounted(){
        this.getDepartments()
    },
    methods:{
        clearForm(){
            this.editing = false
            this.department.Id = null
            this.department.Name = null
            this.department.ParentEmployeeDepartmentId = null
            this.department.BranchId = null
            this.department.Order = null
            this.title.Id = null
            this.title.Name = null
            this.title.BranchId = null
            this.title.MaxEmployeeCount=null
            this.title.EmployeeDepartmentId = null
            this.title.Order = null
            this.title.DriverDepartment = null
            this.title.HRDepartment = null
            this.title.MRODepartment = null
            this.title.CollarStatusId = null
            this.title.AdministrativeLevelId = null
            this.title.AdministrativeLevelGroupId = null
        },
        createNew(item){
            this.clearForm()
            this.department.BranchId = item.BranchId
            this.department.ParentEmployeeDepartmentId = item.Id
            this.$showModal('create-or-update')
        },
        createNewTitle(item){
            this.clearForm()
            this.title.BranchId = item.BranchId
            this.title.EmployeeDepartmentId = item.Id
            this.title.MaxEmployeeCount = item.MaxEmployeeCount
            this.title.DriverDepartment = item.DriverDepartment
            this.title.HRDepartment = item.HRDepartment
            this.title.MRODepartment = item.MRODepartment
            this.title.AdministrativeLevelId = item.AdministrativeLevelId
            this.title.AdministrativeLevelGroupId = item.AdministrativeLevelGroupId
            this.title.CollarStatusId = item.CollarStatus?.Id
            this.$showModal('create-or-update-title')
        },
        showPersonal(data,title){
            this.title.Personal = title.CurrentTitleEmployees?.Employees || []
            this.title.Name = title.Name
            this.$showModal('personal')
        },
        getDepartments(){
            this.getting = true 
            HumanResourcesParameterApi.EmployeeDepartment.TreeList().then(res=>{
                if(res.data.Success){
                    this.departments = res.data.Data
                }
                this.getting = false
            }).catch(err=>{
                this.getting = false
            })
        },
        createOrUpdate(){
            this.loading = true
            HumanResourcesParameterApi.EmployeeDepartment.CreateOrUpdate(this.editing,this.department).then(res=>{
                this.$result(res)
                if(res.data.Success){
                    this.getDepartments()
                    this.$hideModal('create-or-update')
                }
                this.loading = false
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        createOrUpdateTitle(){
            this.loading = true
            HumanResourcesParameterApi.EmployeeDepartmentTitle.CreateOrUpdate(this.editing,this.title).then(res=>{
                this.$result(res)
                if(res.data.Success){
                    this.getDepartments()
                    this.$hideModal('create-or-update-title')
                }
                this.loading = false
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.department.Id = item.Id
            this.department.Name = item.Name
            this.department.ParentEmployeeDepartmentId = item.ParentEmployeeDepartmentId
            this.department.Order = item.Order
            this.$showModal('create-or-update')
        },
        editTitle(item){
            this.clearForm()
            this.editing = true
            this.title.Id = item.Id
            this.title.Name = item.Name
            this.title.EmployeeDepartmentId = item.EmployeeDepartmentId
            this.title.BranchId = item.BranchId
            this.title.MaxEmployeeCount=item.MaxEmployeeCount
            this.title.Order = item.Order
            this.title.DriverDepartment = item.DriverDepartment
            this.title.HRDepartment = item.HRDepartment
            this.title.MRODepartment = item.MRODepartment
            this.title.CollarStatusId = item.CollarStatus?.Id || null
            this.title.AdministrativeLevelId = item.AdministrativeLevelId || null
            this.title.AdministrativeLevelGroupId = item.AdministrativeLevelGroupId || null
            this.$showModal('create-or-update-title')
        },
        del(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} bölümünü ve buna bağlı bölümleri silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HumanResourcesParameterApi.EmployeeDepartment.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.getDepartments()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        delTitle(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli unvanı silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HumanResourcesParameterApi.EmployeeDepartmentTitle.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.getDepartments()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        collapseAll(){
            this.$refs.treeViews.forEach(tv=> tv.collapseAll())
        },
    }
}
</script>

<style>

</style>